import styled from "styled-components";

export const BannerWidgetContainer = styled.div`
  position: relative;
  .banner_container {
    min-height: 218px;
    .banner_item {
      position: relative;
      .banner_img {
        padding-bottom: 16px;
        display: block;
        width: 100%;
        height: auto;
      }
    }
    .swiper-pagination {
      position: absolute;
      bottom: 0;
    }
    .swiper-pagination-bullet {
      border-radius: 12px;
      width: 40px;
      height: 2px;
      background: ${({ theme }) => theme.COLORS.GRAY_7};
      &.swiper-pagination-bullet-active {
        background: ${({ theme }) => theme.COLORS.PURPLE_1};
      }
    }
  }
  .banner_arrow_container {
    .custom_prev {
      cursor: pointer;
      position: absolute;
      top: 42%;
      left: -74px;
      z-index: 10;
    }
    .custom_next {
      cursor: pointer;
      position: absolute;
      top: 42%;
      right: -74px;
      z-index: 2;
    }
  }
  .banner_arrow_mobile_container {
    display: none;
    .custom_prev {
      cursor: pointer;
      position: absolute;
      top: 42%;
      left: 5px;
      z-index: 10;
    }
    .custom_next {
      cursor: pointer;
      position: absolute;
      top: 42%;
      right: 5px;
      z-index: 2;
    }
  }

  @media (max-width: 1274px) {
    .banner_arrow_container {
      .custom_prev {
        left: 20px;
      }
      .custom_next {
        right: 20px;
      }
    }
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.TABLET}) {
    .banner_container {
      width: 100%;
      box-sizing: border-box;
      overflow: hidden;
    }
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.SURFACE_DUO}) {
    .banner_arrow_container {
      display: none;
    }
    .banner_arrow_mobile_container {
      display: block;
    }
  }
`;
